<template>
  <div>
    <top title="申请记录" path="/home">
      <Icon type="md-add" slot="right" @click="toRight" />
      <diaodu-menu slot="center"></diaodu-menu>
    </top>
    <my-tab :tab="tab" :active="active" @tab="reTab"></my-tab>
    <ly-time @timeObj="reTimeObj"></ly-time>
    <div id="mylist" style="top: 130px">
      <List
        v-for="(item, index) in listData"
        :key="index"
        @on-click="openXiangqing(item)"
      >
        <template slot="title">{{ item.user }} </template>
        <template slot="day"
          >创建：{{ utils.time(item.applyTime, "yymmddhhmm") }}</template
        >
        <template slot="des">
          订单编号：{{ item.applyId }} / 联系电话：{{ item.tel }} <br />
          预计用车：{{ utils.time(item.planUseTime, "yymmddhhmm") }}
        </template>
      </List>
    </div>
    <Modal
      v-model="xiangqing"
      title="详情"
      :mask-closable="false"
      width="90%"
      footer-hide
      fullscreen
    >
      <Detail :datas="datas">
        <Row slot="btn" style="margin-top: 20px">
          <!-- <Col span="8"><Button long :disabled="!(applyItem.approvalStatus == 2 || applyItem.taskStatus == 5)">编辑</Button></Col>
          <Col span="8"><Button long :disabled="applyItem.approvalStatus != 0 || applyItem.taskStatus == 5">撤回</Button></Col> -->
          <Col span="24"
            ><Button
              long
              :disabled="applyItem.taskStatus == 2 || applyItem.taskStatus == 3"
              @click="delApply"
              >删除</Button
            ></Col
          >
        </Row>
      </Detail>
    </Modal>
    <Modal
      v-model="evelutionModel"
      title="添加评价"
      :mask-closable="false"
      width="90%"
      @on-ok="evelution"
    >
      <Rate show-text v-model="valueHalf">
        <span style="color: #f5a623">{{ valueHalf }}</span>
      </Rate>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import diaoduMenu from "../common/diaoduMenu.vue";
var delist = [];
export default {
  components: { diaoduMenu },
  data() {
    return {
      applyId: "",
      value: "0", //标签默认展开
      value1: "0", //折叠面板默认展开
      visible: false, //菜单是否可见
      fill: false,
      valueHalf: 4, //评分
      evelutionModel: false,
      listData: [],
      tab: [
        { title: "待审批", mark: 0 },
        { title: "已审批", mark: 1 },
        { title: "被驳回", mark: 2 },
      ],
      active: 0,
      xiangqing: false,
      datas: [],
      applyItem: {},
      timeObj: {},
    };
  },
  methods: {
    //获取计费类型
    getList() {
      var params = {
        approvalStatus: this.active,
        startTime: this.timeObj.start,
        endTime: this.timeObj.end,
      };
      axios({
        method: "post",
        url: axios.dispatch + "/apply/list",
        data: params,
      }).then((res) => {
        var data = res.data.data.dataList;
        this.listData = data;
      });
    },
    reTab(v) {
      this.active = v.mark;
      this.getList();
    },
    openXiangqing(row) {
      console.log(row);
      this.applyItem = row;
      this.xiangqing = true;
      this.datas = [
        {
          title: "单号",
          value: row.applyId,
        },
        {
          title: "用车人",
          value: row.user,
        },
        {
          title: "电话",
          value: row.tel,
        },
        {
          title: "单位名称",
          value: row.groupName,
        },
        {
          title: "开始地点",
          value: row.startAdd,
        },
        {
          title: "送达地点",
          value: row.endAdd,
        },
        {
          title: "预计用车",
          value: this.utils.time(row.planUseTime),
        },
        {
          title: "预计还车",
          value: this.utils.time(row.planReturnTime),
        },
        {
          title: "用车事由",
          value: row.des,
        },
      ];
    },
    //删除申请
    delApply(row) {
      var params = {
        applyIdList: [this.applyItem.applyId],
      };
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除申请？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.dispatch + "/apply/del",
            data: params,
          }).then((res) => {
            this.getList();
            this.xiangqing = false;
          });
        },
      });
    },
    //撤回申请
    revokeApply(row) {
      var params = {
        applyId: row.applyId,
      };
      this.$Modal.confirm({
        title: "撤销导致无法审批，确定要撤销？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.dispatch + "/apply/revoke",
            data: params,
          }).then((res) => {
            this.getList(100);
            if (res.data.code != 200) {
              this.$Message.error({
                content: res.data.message,
                duration: 3,
              });
            }
          });
        },
      });
    },
    //点击更改按钮
    update(row) {
      this.$router.push({
        path: "/scheduling/addApply",
      });
      this.$store.state.applyAdd = false;
    },
    selectMenu(x) {
      this.getList(x);
    },
    toRight() {
      this.$router.push({
        path: "/scheduling/addApply",
      });
      // this.$emit("applyId", 1);
      this.$store.state.applyAdd = true;
    },
    cancelFill() {
      this.fill = false;
    },
    //点击选项卡触发
    changeTabs(x) {
      this.getList(x);
      this.value = x;
    },
    //评价申请
    evelution() {
      let params = new window.FormData();
      params.append("applyId", this.applyId);
      params.append("appraise", this.valueHalf);
      axios({
        method: "post",
        url: "/apply/appraiseApply",
        data: params,
      }).then((res) => {
        if (res.data.code != 200) {
          this.$Message.error(res.data.message);
        }
        this.getList(100);
      });
    },
    reTimeObj(v) {
      this.timeObj = v;
      this.getList();
    },
  },
  mounted() {},
};
</script>


// WEBPACK FOOTER //
// src/components/apply/apply.vue